import MyMap from './map.vue';

MyMap.install = function(Vue){
  Vue.component('MyMap', MyMap);
};

export default MyMap;